import * as ActionTypes from "../ActionTypes";

const initialState = {
    isLoading: false,
    error: false,
    errorMessage: "",
    success: false,
    atsCandidateExport: []
};

export const AtsCandidateExportReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.ATS_CANDIDATE_EXPORT_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
                atsCandidateExport: []
            };
        case ActionTypes.ATS_CANDIDATE_EXPORT_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                atsCandidateExport: action.payload?.data?.data
            };
        case ActionTypes.ATS_CANDIDATE_EXPORT_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}